



























































import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import store from '../store';
import axios from 'axios';

@Component({
  components: {}
})
export default class ProjectView extends Vue {
  public $refs!: {
    form: HTMLFormElement;
  };

  public $auth!: {
    token: string;
    isAdmin: boolean;
  };

  @(namespace('ProjectModule').Action('getProjects'))
  private getProjects!: (token: string) => [];

  @(namespace('ProjectModule').Action('createProject'))
  private createProject!: (payload) => [];

  @(namespace('ProjectModule').Action('updateProject'))
  private updateProject!: (payload) => [];

  @(namespace('ProjectModule').Action('deleteProject'))
  private deleteProject!: (payload) => [];

  @(namespace('CustomerModule').Action('getCustomers'))
  private getCustomers!: (token: string) => null;

  @(namespace('CustomerModule').State('customers'))
  private customers!: [];

  @(namespace('ProjectModule').State('projects')) private projects!: object[];
  private defaultRule = [value => !!value || 'Value Required'];
  private valid = false;
  private dialog = false;
  private editedIndex = -1;
  private loading = true;
  private projectNameFieldDisabled = false;

  private projectRule = this.defaultRule;
  private salesLeadRule = this.defaultRule;
  private applicationRule = this.defaultRule;
  private customer = '';
  private customerRule = this.defaultRule;

  private editedProject = {
    name: '',
    salesLead: '',
    application: ''
  };

  private defaultProject = {
    name: '',
    salesLead: '',
    application: ''
  };

  private snackbar = {
    status: false,
    message: '',
    color: ''
  };

  private headers = [
    { text: 'Project Name', value: 'name' },
    { text: 'Sales Lead', value: 'salesLead' },
    { text: 'Applications', value: 'application' },
    { text: 'Actions', value: 'action', sortable: false }
  ];

  private async created() {
    this.getProjects(this.$auth.token);
    if (this.$auth.isAdmin) this.getCustomers(this.$auth.token);
    this.loading = false;
  }
  get formTitle() {
    return this.editedIndex === -1 ? 'New Project' : 'Edit Project';
  }

  private resetForm() {
    this.dialog = false;
  }

  private edit(project: object) {
    this.projectNameFieldDisabled = true;
    this.editedIndex = this.projects.indexOf(project);
    this.editedProject = Object.assign(this.editedProject, project);
    this.dialog = true;
  }

  private async save() {
    if (this.$refs.form.validate()) {
      const payload = {
        token: this.$auth.token,
        project: { customerId: this.customer, ...this.editedProject },
        index: this.editedIndex
      };
      if (this.editedIndex > -1) {
        this.updateProject(payload);
      } else {
        this.createProject(payload);
      }
      this.close();
    }
  }

  private displaySnackbar(message: string, color: string) {
    this.snackbar.status = true;
    this.snackbar.message = message;
    this.snackbar.color = color;
  }

  private del(project: object) {
    if (confirm('Are you sure you want to delete this project?')) {
      const payload = {
        token: this.$auth.token,
        project,
        index: this.projects.indexOf(project)
      };
      this.deleteProject(payload);
    }
  }

  private close() {
    this.dialog = false;
    this.projectNameFieldDisabled = false;
    this.editedProject = Object.assign({}, this.defaultProject);
    this.editedIndex = -1;
  }
}
